var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 417 417",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 416.667,
    height: 416.667,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.667,83.333c-0,-45.993 -37.341,-83.333 -83.334,-83.333l-250,0c-45.993,0 -83.333,37.34 -83.333,83.333l-0,250c-0,45.993 37.34,83.334 83.333,83.334l250,-0c45.993,-0 83.334,-37.341 83.334,-83.334l-0,-250Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.167,45.833c-0,-11.506 -9.328,-20.833 -20.834,-20.833c-11.505,0 -20.833,9.327 -20.833,20.833l41.667,0Zm-35.565,339.732c8.136,8.136 21.327,8.136 29.463,-0l132.582,-132.583c8.136,-8.136 8.136,-21.327 0,-29.462c-8.136,-8.137 -21.327,-8.137 -29.462,-0l-117.852,117.85l-117.851,-117.85c-8.136,-8.137 -21.327,-8.137 -29.462,-0c-8.137,8.135 -8.137,21.326 -0,29.462l132.582,132.583Zm-6.102,-339.732l0,325l41.667,0l-0,-325l-41.667,0Z",
    style: {
      fill: "#66c461",
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.8ceee5f498c4460711916767595c4541.svg";
export { ForwardRef as ReactComponent };